<template>
  <div class="loan__description">
    <div v-if="formattedEntrepreneurDescription" v-html="formattedEntrepreneurDescription" />
    <div v-if="formattedDescription" v-html="formattedDescription" />
    <div v-if="formattedMfiExtraInfo" v-html="formattedMfiExtraInfo" />
    <p class="date">
      <FontAwesomeIcon icon="clock" />
      {{ $t('approvedAt') }} {{ formattedDate }}
    </p>
  </div>
</template>

<script>
  import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
  import format from 'date-fns/format'
  import parse from 'date-fns/parse'
  import i18n from './locales'

  export default {
    name: 'LoanDetailsDescription',
    i18n,
    props: {
      approvedAt: {
        default: null,
        type: Date,
      },
      description: {
        default: '',
        type: String,
      },
      entrepreneurDescription: {
        default: '',
        type: String,
      },
      mfiExtraInfo: {
        default: '',
        type: String,
      },
    },
    computed: {
      formattedDate () {
        return format(parse(this.approvedAt), 'D MMMM YYYY')
      },
      /**
       * Split the loan description content by new line and treat each line as a paragraph.
       * @return {string}
       */
      formattedDescription () {
        const loanDescription = this.$get(this, 'description', null)

        return this.textToParagraphs(loanDescription)
      },
      /**
       * Split the entrepreneur description content by new line and treat each line as a paragraph.
       * @return {string}
       */
      formattedEntrepreneurDescription () {
        const entrepreneurDescription = this.$get(this, 'entrepreneurDescription', null)

        return this.textToParagraphs(entrepreneurDescription)
      },
      /**
       * Split the MFI extra info content by new line and treat each line as a
       * paragraph.
       * @return {string}
       */
       formattedMfiExtraInfo () {
        const mfiExtraInfo = this.$get(this, 'mfiExtraInfo', null)

        return this.textToParagraphs(mfiExtraInfo)
      },
    },
    methods: {
      /**
       * @param {string} str
       * @return {string}
       */
      textToParagraphs (str) {
        if (typeof str !== 'string' || !str.length) return ''

        return str
          .split('\n')
          .map(text => `<p>${text}</p>`)
          .join('')
      },
    },
    created () {
      this.$fa.add(faClock)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~foundation-sites/scss/util/_unit";
  @import "~foundation-sites/scss/util/_breakpoint";

  .loan__description {
    .date {
      margin-top: 2rem;
      color: $colour-grey;
      font-style: italic;

      svg {
        color: $colour-magnolia-dark;
        font-size: 1.2rem;
        transform: translateY(1px);
        margin-right: 0.25rem;
      }
    }
  }
</style>
